import React from 'react'

import { StickyHeaderProps } from './StickyHeaderProps';

import './styles.css';

const StickyHeader: React.FC<StickyHeaderProps> = ({
    backIcon,
    isSticky,
    headingText,
    headingTextColor,
    onBackPress
}) => {
    return (
        <div className={`stkyHdr ${isSticky ? 'isSticky' : ''}`}>
            <img className='stkyHdr__icon' src={backIcon} alt="back icon" onClick={onBackPress} />
            {(headingText && isSticky) && <p className='stkyHd__text' style={{ color: headingTextColor }}>{headingText}</p>}
        </div>
    )
}

export default StickyHeader;